import { rfqQuoteTypes } from '@/data/rfq-quote-types'

export const condensedProposal = {
  proposal_type: 'condensed',
  project_info : {
    name: {
      label: 'Project Name',
      f_component: 'VTextField',
      d_component: null,
      bind: {
        disabled: true
      },
      value: 'Fram & Slokker'
    },
    address: {
      label: 'Project Address',
      f_component: 'VTextField',
      d_component: null,
      bind: {
        disabled: true
      },
      value: '55 Port Street, Mississauga, ON'
    },
    sales_person: {
      label: 'Sales Person',
      f_component: 'VTextField',
      d_component: null,
      bind: {
        disabled: true
      },
      value: {
        'From': 'Kevin Monsour',
        'Phone': '+1 888.222.222',
        'Mobile': '(416)999-999',
        'Email': 'email@email.com',
        'Estimator': 'Neda Emam'
      }
    },
    contact: {
      label: 'Proposal Contact',
      f_component: 'VSelect',
      d_component: 'VContactTable',
      bind: {
        itemText: 'Name',
        options: [
          {
            'To': 'Contact 1',
            'Name': '',
            'Phone': '416.222.222',
            'Email': 'email@email.com',
            'Quote No.': 192238
          },
          {
            'To': 'Contact 2',
            'Name': '',
            'Phone': '416.222.221',
            'Email': 'email@email.com',
            'Quote No.': 192238
          },
        ]
      },
      value: {
        'To': '',
        'Name': '',
        'Phone': '',
        'Email': '',
        'Quote No.': ''
      }
    },
    date: {
      label: 'Proposal Date',
      f_component: 'VDatePicker',
      d_component: null,
      value: null
    },
    quote_no: {
      label: 'Proposal Date',
      f_component: 'VTextField',
      d_component: null,
      value: null
    },
    cover_photo: {
      label: 'Proposal Cover Photo',
      f_component: 'VDropZone',
      d_component: null,
      value: {
        file: '',
        name: '',
        url: ''
      }
    },
    pricing: {
      rfq_id: null
    }
  },
  proposal_info: [
    {
      id: 'quote_type',
      label: 'Quote Type',
      f_component: 'VSelect',
      d_component: 'custom',
      bind: {
        options: rfqQuoteTypes
      },
      value: 'dpa_turnkey'
    },
    {
      id: 'material_onsite',
      label: 'Material Onsite',
      f_component: 'VTextField',
      d_component: 'custom',
      bind: {
        placeholder: 'Material Onsite Date, e.g. Q4 2024'
      },
      value: null
    },
    {
      id: 'documents',
      label: 'Documents',
      f_component: 'VDynamicList',
      d_component: 'VDocTable',
      bind: {
        rowTemplate: [
          { 
            label: 'name',
            component: 'VTextField',
            bind: {},
            default: ''
          },
          { 
            label: 'received_on',
            component: 'VDatepicker',
            bind: {},
            default: null 
          },
          {
            label: 'details',
            component: 'VTextField',
            bind: {
              placeholder: "Enter other details for document"
            },
            default: ''
          }
        ],
        isColumn: true
      },
      value: []
    },
    {
      id: 'project_scope_notes',
      label: 'Project Scope Notes',
      f_component: 'VRichText',
      d_component: 'VRichTextRenderer',
      bind: {
        placeholder: 'Enter project scope notes'
      },
      value: ''
    }
  ],
  proposal_content: [
    {
      name: 'Materials',
      id: 'materials',
      f_component: 'VDynamicList',
      d_component: '',
      type: 'dynamicSubsections',
      f_bind: { hasAddButton: true },
      d_bind: { class: 'break-after' },
      subsection_template: [
        {
          label: 'image',
          component: 'VFileUpload',
          tag: 'img',
          bind: {
            hasName: true
          },
          default: {
            file: '',
            name: '',
            url: ''
          }
        },
        {
          label: 'material',
          component: 'VTextField',
          tag: 'h3',
          bind: {
            placeholder: 'Architecture Name'
          },
          default: ''
        },
        {
          label: 'material_type',
          component: 'VTextField',
          tag: 'h3',
          bind: {
            placeholder: 'Material Type, e.g. Mitrex Facing Panel'
          },
          default: 'Mitrex Facing Panel'
        },
        {
          label: 'text',
          component: 'VTextField',
          tag: 'p',
          bind: {
            placeholder: 'Material description',
            counter: true,
            counterValue: 160
          },
          default: ''
        },
        {
          label: 'visible',
          default: true
        }
      ],
      subsections: [
        {
          material: 'material 1',
          material_type: 'Mitrex Facing Panel',
          text: '',
          image: {
            file: '',
            name: 'file_placeholder.png',
            url: 'https://bulma.io/assets/images/placeholders/800x480.png'
          },
          visible: true
        },
        {
          material: 'material 2',
          material_type: 'Mitrex Facing Panel',
          text: '',
          image: {
            file: '',
            name: 'file_placeholder.png',
            url: 'https://bulma.io/assets/images/placeholders/800x480.png'
          },
          visible: true
        }
      ]
    },
    {
      name: 'Project Highlights',
      id: 'drawing_highlight',
      f_component: 'VDynamicList',
      d_component: 'VSubsection',
      type: 'dynamicSubsections',
      f_bind: {
        hasAddButton: true
      },
      subsection_template: [
        {
          label: 'elevation',
          component: 'VTextField',
          tag: 'h2',
          bind: {
            placeholder: 'Drawing highlight title'
          },
          default: 'North Elevation'
        },
        {
          label: 'text',
          component: 'VTextField',
          tag: 'p',
          bind: {
            placeholder: 'Drawing highlight description'
          },
          default: ''
        },
        {
          label: 'image',
          component: 'VFileUpload',
          tag: 'img',
          display_class: "drawing-highlight",
          bind: {
            hasName: true
          },
          default: {
            file: '',
            name: '',
            url: ''
          }
        }
      ],
      subsections: [
        {
          elevation: 'North Elevation',
          text: '',
          image: {
            file: '',
            name: 'file_placeholder.png',
            url: 'https://bulma.io/assets/images/placeholders/800x480.png'
          }
        },
        {
          elevation: 'South Elevation',
          text: '',
          image: {
            file: '',
            name: 'file_placeholder.png',
            url: 'https://bulma.io/assets/images/placeholders/800x480.png'
          }
        },
        {
          elevation: 'East Elevation',
          text: '',
          image: {
            file: '',
            name: 'file_placeholder.png',
            url: 'https://bulma.io/assets/images/placeholders/800x480.png'
          }
        }
      ]
    },
    {
      id: 'inclusions_exclusions',  
      name: 'Inclusions & Exclusions',
      type: 'optional',
      visible: true,
      component: 'InclusionsAndExclusions'
    },
    {
      name: 'Installation Method',
      id: 'install_method',
      f_component: 'VDynamicList',
      d_component: 'InstallationMethodCondensed',
      type: 'dynamicSubsections',
      f_bind: { hasAddButton: true },
      subsection_template: [
        {
          label: 'method',
          component: 'VTextField',
          tag: 'h2',
          bind: {
            placeholder: 'Installation method title'
          },
          default: ''
        },
        {
          label: 'text',
          component: 'VRichText',
          tag: 'p',
          bind: {
            placeholder: 'Installation method description'
          },
          default: ''
        },
        {
          label: 'list',
          component: 'VRichText',
          tag: 'p',
          bind: {
            placeholder: 'Installation method benefits'
          },
          default: ''
        },
        {
          label: 'image',
          component: 'VFileUpload',
          tag: 'img',
          bind: {
            hasName: true
          },
          default: {
            file: '',
            name: '',
            url: ''
          }
        },
        {
          label: 'visible',
          default: true
        }
      ],
      subsections: [
        {
          method: 'method 1',
          text: '',
          list: '',
          image: {
            file: '',
            name: 'file_placeholder.png',
            url: 'https://bulma.io/assets/images/placeholders/800x480.png'
          },
          visible: true
        }
      ]
    },
    {
      id: 'pricing_summary',
      name: 'Pricing Summary',
      f_component: 'VDynamicList',
      d_component: 'VSubsection',
      type: 'dynamicSubsections',
      visible: true,
      subsection_template: [
        {
          label: 'title',
          component: 'VTextField',
          tag: 'h2',
          bind: {
            placeholder: 'Pricing summary section title'
          },
          default: ''
        },
        {
          label: 'text',
          component: 'VTextField',
          tag: 'p',
          bind: {
            placeholder: 'Pricing summary section description',
            counter: true,
            counterValue: 160
          },
          default: ''
        },
        {
          label: 'image',
          component: 'VFileUpload',
          tag: 'img',
          bind: {
            hasName: true
          },
          default: {
            file: '',
            name: '',
            url: '',
          }
        }
      ],
      subsections: [
        {
          title: 'Pricing Summary 1',
          text: '',
          image: {
            file: '',
            name: '',
            url: '',
          }
        }
      ]
    },
    {
      name: 'Alternate Option',
      id: 'alternate_option',
      f_component: 'VDynamicList',
      d_component: 'AlternateOptionCondensed',
      type: 'dynamicSubsections',
      f_bind: { hasAddButton: true },
      subsection_template: [
        {
          label: 'option',
          component: 'VTextField',
          tag: 'h2',
          bind: {
            placeholder: 'Alternate Option title'
          },
          default: ''
        },
        {
          label: 'text',
          component: 'VRichText',
          tag: 'p',
          bind: {
            placeholder: 'Alternate option description'
          },
          default: ''
        },
        {
          label: 'list',
          component: 'VRichText',
          tag: 'p',
          bind: {
            placeholder: 'Alternate option list'
          },
          default: ''
        },
        {
          label: 'summary',
          component: 'VRichText',
          tag: 'p',
          bind: {
            placeholder: 'Alternate option summary'
          },
          default: ''
        },
        {
          label: 'note',
          component: 'VTextField',
          tag: 'p',
          bind: {
            placeholder: 'Alternate option note'
          },
          default: ''
        },
        {
          label: 'image',
          component: 'VFileUpload',
          tag: 'img',
          bind: {
            hasName: true
          },
          default: {
            file: '',
            name: '',
            url: ''
          }
        },
        {
          label: 'visible',
          default: true
        }
      ],
      subsections: [
        // {
        //   option: 'option 1',
        //   text: '',
        //   list: '',
        //   summary: '',
        //   note: '',
        //   image: {
        //     file: '',
        //     name: 'file_placeholder.png',
        //     url: 'https://bulma.io/images/placeholders/800x480.png'
        //   },
        //   visible: false
        // }
      ]
    },
    {
      id: 'past_projects',  
      name: 'Projects',
      type: 'optional',
      visible: true,
      component: 'PastProjectsCondensed'
    },
    {
      id: 'last_page',  
      name: 'Last Page',
      type: 'optional',
      visible: true,
      component: 'LastPageCondensed',
      bind: {
        productBrand: 'Mitrex'
      }
    }
  ]
}
